import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderShell } from "@/components/admin/PlaceholderShell";
import { AdminSubNav, CHATBOT_TABS } from "@/components/admin/AdminSubNav";

export const Route = createFileRoute("/admin/chatbot/transfer")({
  head: () => ({
    meta: [
      { title: "Live transfer · Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ChatbotTransfer,
});

function ChatbotTransfer() {
  return (
    <div>
      <AdminSubNav tabs={CHATBOT_TABS} />
      <PlaceholderShell
        title="Live transfer"
        description="Hand a conversation to a loan officer without losing context."
        checklist={[
        "Availability schedule per loan officer",
        "Transfer rules by product and loan size",
        "Notification routing",
        "Post-transfer follow-up tracking",
        ]}
      />
    </div>
  );
}
